import {defineMessages} from 'react-intl';

export const K_DATE = 'date';
export const K_DISTANCE = 'distance';
export const K_PRICE = 'price';
export const K_POPULAR = 'popularity';

export default defineMessages({
  date: {
    id: 'EventSorter.Date',
    defaultMessage: 'Date',
  },
  distance: {
    id: 'EventSorter.Distance',
    defaultMessage: 'Distance',
  },
  price: {
    id: 'EventSorter.Price',
    defaultMessage: 'Price',
  },
  popularity: {
    id: 'EventSorter.Popular',
    defaultMessage: 'Popular',
  },
});

export const titleMessages = defineMessages({
  date: {
    id: 'EventSorter.TitleDate',
    defaultMessage: 'Sort by date',
  },
  distance: {
    id: 'EventSorter.TitleDistance',
    defaultMessage: 'Sort by distance',
  },
  price: {
    id: 'EventSorter.TitlePrice',
    defaultMessage: 'Sort by price',
  },
  popularity: {
    id: 'EventSorter.TitlePopular',
    defaultMessage: 'Sort by popular',
  },
});

export const sortValues = {
  date: {
    sort: 'eventDateLocal asc',
    reRankBy: 'relevance',
  },
  distance: {
    sort: 'distance asc,eventDateLocal asc',
    reRankBy: 'relevance',
  },
  price: {
    sort: 'minPrice asc',
    reRankBy: 'relevance',
  },
  popularity: {
    sort: 'trending desc',
    reRankBy: 'relevance',
  },
};
